import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: `A team of lawyers answers all your legal questions related to your activity over the phone. You can contact them from Monday to Saturday between 9 AM and 6 PM, with a limit of 10 calls per year. Just call the free number below:`,
    phoneNumber: '+33 4 12 34 56 78',
    title: 'How does it work?',
  },
  fr: {
    description: `Une équipe de juristes répond par téléphone à toutes vos questions légales liées à votre activité. Vous pouvez les contacter du lundi au samedi entre 9h et 18h. Dans la limite de 10 appels par an. Il suffit d'appeler le numéro gratuit ci-dessous :`,
    phoneNumber: '+33 4 12 34 56 78',
    title: 'Comment ça marche ?',
  },
} as const);

export default locales;
